import React from 'react';
import I18n from 'i18n-js';
import { RCTextWithIcon } from '@reverbdotcom/cadence/components';
import { ClockCounterClockwiseIcon } from '@phosphor-icons/react';

import { Listing, NextBestAction } from '@reverbdotcom/commons/src/gql/graphql';
import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';
import { RCTextUtility } from '@reverbdotcom/cadence/components/RCText/RCText';

import { CTA_TYPE, INSIGHT, trackClicked, useTrackingContext, useTrackImpression } from './sellerRecommendationTracking';
import RenewListingButton from '../listings/RenewListingButton';

interface Props {
  listing: Listing;
  nextBestAction?: NextBestAction;
}

export default function RenewListingPresentment({ listing, nextBestAction }: Props) {
  const trackingContext = useTrackingContext();
  useTrackImpression(INSIGHT.RENEW_ELIGIBLE, listing.id);

  const relistDescription = listing.priceRecommendation?.priceMiddle?.display ?
    I18n.t(
      'discovery.listingsManagement.sellerListingCard.insights.renewEligible.descriptionWithPriceRec',
      { displayPrice: listing.priceRecommendation?.priceMiddle?.display },
    ) : I18n.t('discovery.listingsManagement.sellerListingCard.insights.renewEligible.description');

  return (
    <>
      <div className="seller-listing-insight-presentment">
        <span className="seller-listing-insight-presentment__renew-eligible">
          <RCTextWithIcon icon={<ClockCounterClockwiseIcon weight="duotone" />} placement="left" size="large">
            <RCTextUtility size="350">
              {nextBestAction ? <SanitizedRender html={nextBestAction.title ?? ''} /> : relistDescription}
            </RCTextUtility>
          </RCTextWithIcon>
        </span>
        {!!nextBestAction?.subtitle && (
          <RCTextUtility size="350">
            <SanitizedRender html={nextBestAction.subtitle} />
          </RCTextUtility>
        )}
        <RenewListingButton
          listing={listing}
          label={nextBestAction?.ctaText ?? undefined}
          onClick={() => trackClicked(INSIGHT.RENEW_ELIGIBLE, listing.id, CTA_TYPE.RENEW, trackingContext)}
        />
      </div>
    </>
  );
}
